module.exports = __webpack_public_path__ + "img/折磨.3f611023.gif";